import { FlightLandOutlinedIcon } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { CreateLandingPageButton } from '../CreateButton/CreateButton';
import styles from './reportEmptyState.module.scss';

export const LandingPagesReportEmptyState = () => (
    <div className={styles['container-empty']}>
        <FlightLandOutlinedIcon className={styles['icon']} />
        <div className={styles['header']}>
            <FormattedMessage
                className={styles['header']}
                id="landing.pages.report.empty.header.updated"
                defaultMessage="No Advertorial was created"
            />
        </div>
        <div className={styles['content-empty']}>
            <FormattedMessage
                id="landing.pages.report.empty.content.updated"
                defaultMessage="Create your first Advertorial to enhance your creatives"
            />
            <div className={styles['create-button']}>
                <CreateLandingPageButton />
            </div>
        </div>
    </div>
);
